import { render, staticRenderFns } from "./ButtonRound.vue?vue&type=template&id=ec376734&lang=pug"
import script from "./ButtonRound.vue?vue&type=script&lang=js"
export * from "./ButtonRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports